export default __webpack_public_path__ + "static/thumb-landscape-bf99f96b590987cd4e9cf3535def7127.jpg";